import React from 'react';

export default [
  {
    value: 'COMERCOS_SERVEIS',
    label: 'Comerços i serveis',
    children: [
      {
        value: 'eix-sarria',
        label: 'Eix Sarrià'
      },
      {
        value: 'ALIMENTARI',
        label: 'Alimentari',
        children: [
          { value: 'pastisseries', label: 'Pastisseries' },
          { value: 'botiga-alimentacio', label: 'Botiga d’alimentació' },
          { value: 'carnisseries', label: 'Carnisseries' },
          { value: 'polleries', label: 'Polleries' },
          { value: 'xarcuteries', label: 'Xarcuteries' },
          { value: 'supermercats', label: 'Supermercats' },
          { value: 'forns-pa', label: 'Forns de pa' },
          { value: 'obradors', label: 'Obradors' }
        ]
      },
      {
        value: 'NO_ALIMENTARI',
        label: 'No alimentari',
        children: [
          { value: 'llibreria', label: 'Llibreria' },
          { value: 'drogueria', label: 'Drogueria' },
          { value: 'matalasseria', label: 'Matalasseria' },
          { value: 'papereria', label: 'Papereria' },
          { value: 'cuina', label: 'Cuina' },
          { value: 'esports', label: 'Esports' },
          { value: 'merceries', label: 'Merceries' },
          { value: 'cosmetica', label: 'Cosmètica' },
          { value: 'ferreteries', label: 'Ferreteries' },
          { value: 'brodats', label: 'Brodats' },
          { value: 'serralleries', label: 'Serralleries' },
          { value: 'llar', label: 'Llar' },
          { value: 'decoracio', label: 'Decoració' },
          { value: 'disseny-cuines', label: 'Disseny de cuines' },
          { value: 'joguines', label: 'Joguines' },
          { value: 'lloguer-material-festes', label: 'Material per festes' },
          { value: 'herboristeria', label: 'Herboristeria' }
        ]
      },
      {
        value: 'MODA',
        label: 'Moda',
        children: [
          { value: 'roba', label: 'Roba' },
          { value: 'roba-infantil', label: 'Roba infantil' },
          { value: 'roba-complements', label: 'Roba complements' },
          { value: 'sabateria', label: 'Sabateria' },
          { value: 'bijuteria', label: 'Bijuteria' }
        ]
      },
      {
        value: 'RESTAURACIO',
        label: 'Restauració',
        children: [
          { value: 'iogurteria', label: 'Iogurteria' },
          { value: 'cafeteria', label: 'Cafeteria' },
          { value: 'gelateria', label: 'Gelateria' },
          { value: 'bar-braseria', label: 'Bar-braseria' },
          { value: 'bar', label: 'Bar' },
          { value: 'restaurant', label: 'Restaurant' }
        ]
      }
    ]
  },
  {
    value: 'EQUIPAMENTS_SOCIO_SANITARIS',
    label: 'Equipaments socio-sanitaris',
    children: [
      { value: 'hospitals', label: 'Hospitals' },
      { value: 'hospitals-dia', label: 'Hospitals de dia' },
      { value: 'sanitario-assistencial', label: 'Sanitario-assistencial' },
      { value: 'cap', label: 'CAPs' },
      { value: 'clubs-esportius', label: 'Clubs esportius' },
      { value: 'espais-esportius', label: 'Espais esportius' },
      { value: 'gimnasos', label: 'Gimnasos' },
      { value: 'centres-ioga', label: 'Centres de ioga' },
      { value: 'estudis-pilates', label: 'Estudis de pilates' },
      { value: 'casals-gent-gran', label: 'Casals de gent gran' },
      { value: 'residencies', label: 'Residencies' }
    ]
  },
  {
    value: 'CENTRES_FORMACIO',
    label: 'Centres de formació',
    children: [
      { value: 'escoles', label: 'Escoles' },
      { value: 'universitats', label: 'Universitats' },
      {
        value: 'EXTRAESCOLARS',
        label: 'Extraescolars',
        children: [
          { value: 'escoles-musica', label: 'Escoles de música' },
          { value: 'escoles-dansa', label: 'Escoles de dansa' },
          { value: 'escoles-art', label: 'Escoles d’art' },
          { value: 'ensenyament-joieria', label: 'Ensenyament de joieria' }
        ]
      }
    ]
  },
  {
    value: 'OCI_CULTURA',
    label: 'Oci i cultura',
    children: [
      { value: 'espais-autogestionats', label: 'Espais autogestionats' },
      { value: 'mercat', label: 'Mercat' },
      { value: 'teatres', label: 'Teatres' },
      { value: 'centres-civics', label: 'Centres cívics' },
      { value: 'esplais-caus', label: 'Esplais i caus' },
      { value: 'centres-culturals', label: 'Centres culturals' },
      { value: 'educacio-artistica', label: 'Educació artística' }
    ]
  },
  {
    value: 'ESPAI_PUBLIC',
    label: 'Espai públic',
    children: [
      {
        value: 'ACTIVITATS',
        label: 'Activitats',
        children: [
          { value: 'esperar', label: (<span>Esperar <div className="icon icon-foto"></div></span>) },
          { value: 'descansar', label: (<span>Descansar <div className="icon icon-foto"></div></span>) },
          { value: 'passejar', label: (<span>Passejar <div className="icon icon-foto"></div></span>) },
          { value: 'relacionarse', label: (<span>Relacionar-se <div className="icon icon-foto"></div></span>) },
          { value: 'fer-esport', label: (<span>Fer esport <div className="icon icon-foto"></div></span>) },
          { value: 'jugar', label: (<span>Jugar <div className="icon icon-foto"></div></span>) },
          { value: 'desplacarse', label: (<span>Desplaçar-se <div className="icon icon-foto"></div></span>) }
        ]
      },
      {
        value: 'ELEMENTS_FISICS',
        label: 'Elements físics',
        children: [
          { value: 'bancs', label: 'Bancs' },
          { value: 'bancs-unipersonals', label: 'Bancs unipersonals' },
          { value: 'arquitectura', label: (<span>Arquitectura <div className="icon icon-foto"></div></span>) },
          { value: 'mobiliari-urba', label: (<span>Mobiliari urbà <div className="icon icon-foto"></div></span>) },
          { value: 'facanes', label: (<span>Façanes <div className="icon icon-foto"></div></span>) },
          { value: 'escales', label: 'Escales' },
          { value: 'fonts', label: 'Fonts' },
          { value: 'vegetacio', label: (<span>Vegetació <div className="icon icon-foto"></div></span>) }
        ]
      }
    ]
  }
];
